import { DateTime } from 'luxon'
import profileInfoSelectors from 'models/ProfileInfo/selectors'
import generalSelectors from 'models/General/selectors'

// TODO: We should not be sending any attributes if profile is not fetched yet
const formatCreationDate = (state) =>
  profileInfoSelectors.statusSuccess(state)
    ? {
        creation_date: DateTime.fromISO(profileInfoSelectors.getUserCreationDate(state)).toISO(),
      }
    : {}

export default class UserAnalyticsProperties {
  constructor(state) {
    this.state = state
  }

  getUserProperties = () => {
    const { state } = this
    return state
      ? {
          email: profileInfoSelectors.getPrimaryEmailAddress(state),
          phone_number: profileInfoSelectors.getPrimaryPhoneNumber(state),
          user_alias: profileInfoSelectors.getUserAlias(state),
          user_code: profileInfoSelectors.getUserCode(state),
          user_handle: profileInfoSelectors.getUserHandle(state),
          has_profile_picture: !!profileInfoSelectors.getProfilePictureUrl(state),
          referral_referee_count: profileInfoSelectors.getReferralRefereeCount(state),
          country: generalSelectors.getRegion(state),
          balance: profileInfoSelectors.getBalance(state),
          rewards_level: profileInfoSelectors.getRewardsLevel(state),
          is_push_notification_enabled: profileInfoSelectors.isPushNotificationsEnabled(state),
          is_email_notification_enabled: profileInfoSelectors.getIsEmailNotificationsEnabled(state),
          is_sms_notification_enabled: profileInfoSelectors.getIsSMSNotificationsEnabled(state),
          ...formatCreationDate(state),
          is_profile_rewards_in_progress: profileInfoSelectors.getIsProfileRewardsInProgress(state),
          is_profile_rewards_eligible: profileInfoSelectors.getIsProfileRewardsEligible(state),
          is_shopping_rewards_in_progress: profileInfoSelectors.getIsShoppingRewardsInProgress(state),
          is_shopping_rewards_eligible: profileInfoSelectors.getIsShoppingRewardsEligible(state),
          is_browsing_rewards_in_progress: profileInfoSelectors.getIsBrowsingRewardsInProgress(state),
          is_browsing_rewards_eligible: profileInfoSelectors.getIsBrowsingRewardsEligible(state),
          is_device_rewards_eligible: profileInfoSelectors.getIsDeviceRewardsEligible(state),
          is_unveil_seen: profileInfoSelectors.getIsUnveilSeen(state),
          is_kid_profiles_checked: profileInfoSelectors.getIsKidProfilesChecked(state),
          has_matching_kid_profiles: profileInfoSelectors.getHasMatchingKidProfiles(state),
          subscription_type: profileInfoSelectors.getSubscriptionType(state),
          subscription_billing_cycle: profileInfoSelectors.getSubscriptionBillingCycle(state),
          is_subscription_renewal_enabled: profileInfoSelectors.getIsSubscriptionRenewalEnabled(state),
          has_pending_transactions: profileInfoSelectors.getHasPendingTransactions(state),
          pending_transactions_amount: profileInfoSelectors.getPendingTransactionsAmount(state),
        }
      : {}
  }
}
